import { getSearchProps, setSearchRoute } from '../../../../helpers/history';

export const getQueryFromMediaLibraryOrRoute = (mediaLibraryQueryContext) => {
  if (mediaLibraryQueryContext?.getQuery) {
    return mediaLibraryQueryContext.getQuery() || {};
  }
  return getSearchProps();
};

export const applyMediaLibraryOrRouteQuery = (queryItems, mediaLibraryQueryContext) => {
  if (mediaLibraryQueryContext?.setQuery) {
    mediaLibraryQueryContext.setQuery(queryItems);
    return;
  }
  setSearchRoute(queryItems, { isProducts: false });
};
